import React, { useCallback, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { ColorPicker } from 'ui/atoms'
import { updateProperty } from 'providers/redux/actions'
import ProductService from 'services/ProductService'
import ConfigService from 'services/ConfigService'

export default function ProductColorPicker({ className, productId, label, defaultColor, colors }) {
  const { color: productColor } = useSelector(state => state.properties[productId]) || {}
  const { orderable } = ProductService.findProductById(productId) || {}
  const productColors = colors || ProductService.getProductProperty(productId, 'colors') || []
  const dispatch = useDispatch()

  const updateColor = useCallback(
    newColor => {
      if (!productColors.findIndex(color => color === newColor) < 0) return
      dispatch(updateProperty(productId, { color: newColor }))
    },
    [dispatch, productId, productColors]
  )

  useEffect(() => {
    if (defaultColor && defaultColor !== productColor) {
      updateColor(defaultColor)
    } else if (!productColor && productColors[0]) {
      updateColor(productColors[0])
    }
  })

  return (
    <ColorPicker
      className={className}
      disabled={!orderable}
      label={label}
      color={productColor}
      colors={productColors.map(value => ({
        value,
        label:
          ConfigService.get('colors')[value] ||
          value.replace(/((^|[_])[a-z])/gi, $1 => $1.toUpperCase().replace(/[_]/g, ' '))
      }))}
      onChange={updateColor}
    />
  )
}

ProductColorPicker.propTypes = {
  className: PropTypes.string,
  productId: PropTypes.string.isRequired,
  label: PropTypes.string,
  defaultColor: PropTypes.string,
  colors: PropTypes.arrayOf(PropTypes.string)
}
